// The filter panel stores a custom field filter under one key per field. The key holds the definition's
// global id, so renaming the field changes nothing. The panel writes the field's Exclude toggle beside it
// as `<key>_operators`, which is not itself a filter key.
export const CUSTOM_FIELD_FILTER_PREFIX = 'customField:';

const OPERATORS_SUFFIX = '_operators';

export const customFieldFilterKey = (definitionId: string): string => `${CUSTOM_FIELD_FILTER_PREFIX}${definitionId}`;

export const isCustomFieldFilterKey = (key: string): boolean =>
	key.startsWith(CUSTOM_FIELD_FILTER_PREFIX) && !key.endsWith(OPERATORS_SUFFIX);

export const definitionIdOf = (key: string): string => key.slice(CUSTOM_FIELD_FILTER_PREFIX.length);
